import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// AWS Amplify components
import { API, Auth } from 'aws-amplify'

// GraphQL
import { listAreas2 } from 'graphql/queries'

import { Autocomplete, TextField } from '@mui/material'

import { useUser } from 'components/RDAuthContext'


export default function AreaSelector(props){
  
  const [areaList, setAreaList] = useState([])
  const [companyAreas, setCompanyAreas] = useState([])
  const [franchiseAreas, setFranchiseAreas] = useState([])
  const [filterList, setFilterList] = useState({})
  const [data, setData] = useState(null)

  async function getAreaList(){
    console.log('getAreaList...')
    try {
      const queryResponse = await API.graphql({
        query: listAreas2,
        variables: {
          report: 'r0002_area_selector'
        }
      })
      console.log('queryResponse', queryResponse)
      setData(queryResponse.data.listAreas2)
    } catch (err) {
      console.log('Error fetching Areas data', err)
    }
  }

  useEffect(() => {
    getAreaList()
  }, [])

  useEffect(() => {

    if(data){
      // Filter data to only include areas with active stores
      const areasWithActiveStores = data.filter(area => {
        const activeStores = area.stores.filter(x => (x.status !== 'Closed' && x.status !== 'New'))
        return activeStores.length > 0
      })

      // Set areaList
      const company_Areas = areasWithActiveStores.filter(x => x.areaType === 'Company').map(y => y.areaName).sort()
      const franchise_Areas = areasWithActiveStores.filter(x => x.areaType === 'Franchise').map(y => y.areaName).sort()
      company_Areas.unshift('All')
      franchise_Areas.unshift('All')
      setCompanyAreas(company_Areas)
      setFranchiseAreas(franchise_Areas)

      if(props.pageType === 'Company'){
        setAreaList(company_Areas)
      } else if(props.pageType === 'Franchise'){
        setAreaList(franchise_Areas)
      }

      // Set filterList - only for areas with active stores
      let storeList = areasWithActiveStores.reduce((arr, manager) => {
        const { areaName, stores } = manager

        let storeNames = stores.filter(x => (x.status !== 'Closed' && x.status !== 'New')).map(x => x.shortName)
        storeNames.push(areaName)
        storeNames.push(`${areaName} Total`)
        return {...arr, [areaName]: storeNames}
      }, {})
      setFilterList(storeList)
    }
  }, [data])

  useEffect(() => {
    if(props.pageType === 'Company'){
      setAreaList(companyAreas)
    } else if(props.pageType === 'Franchise'){
      setAreaList(franchiseAreas)
    }
  }, [props.pageType])

  

  function handleAreaSelection(event, area){
    if(area !== 'All'){
      props.onChange(area, filterList[area])
    } else {
      props.onChange(area, filterList)
    }
  }

  

  return (
    <div>
      <Autocomplete 
        id='r0002AreaSelector'
        options={ areaList }
        value={ props.area }
        onChange={ handleAreaSelection }
        defaultValue='All'
        disableClearable={true}
        size='small'        
        renderInput={(params) => 
          <TextField 
            {...params} 
            label='Area' 
            variant='outlined' 
            fullWidth
            sx={{
              '& .MuiFormLabel-root': {               
                color: '#CF9E0B'
              },
              '& .MuiInputBase-input': {
                color: '#CF9E0B',
                // '& .MuiAutocomplete-inputFocused': {
                //   bgcolor: 'red'
                // }
              }
            }}
          /> 
        }
        sx={{
          '& .MuiAutocomplete-inputRoot': {
            color: 'white',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#CF9E0B',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#906e07'
            },
            '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#906e07'
            },
            '& .MuiAutocomplete-inputFocused': {
              bgcolor: '#29261F'
            },
            '& .MuiAutocomplete-endAdornment': {
              '& .MuiIconButton-root': {
                color: '#cf9e0b'
              }
            },
          }
        }}
      />
    </div>
  )


}

AreaSelector.propTypes = {
  area: PropTypes.string,
  onChange: PropTypes.func,
  pageType: PropTypes.string,
}